import { Components } from '@mui/material';

import tokens from '../tokens';

const MuiChip: NonNullable<Components['MuiChip']> = {
  styleOverrides: {
    colorPrimary: {
      backgroundColor: tokens.palette.common.black,
    },
    colorSecondary: {
      backgroundColor: tokens.palette.warning.light,
    },
    colorError: {
      backgroundColor: tokens.palette.error.main,
    },
    colorInfo: {
      backgroundColor: tokens.palette.info.main,
    },
    colorSuccess: {
      backgroundColor: tokens.palette.success.main,
    },
    colorWarning: {
      backgroundColor: tokens.palette.warning.main,
    },
  },
};

export default MuiChip;
